export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: { },
  mutations: {
    add(state, payload) { state.items.push(payload); },
    remove(state, payload) { state.items = state.items.filter(i => i !== payload); },
  },
};
